import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/axios";

/* ================= FETCH SIZES ================= */
export const fetchSizes = createAsyncThunk(
  "size/fetch",
  async ({ page = 1, limit = 10 }, thunkAPI) => {
    try {
      const res = await  api.get(
        `/api/sizes?page=${page}&limit=${limit}`
      );
      return res.data;
    } catch (err) {
      return thunkAPI.rejectWithValue("Failed to fetch sizes");
    }
  }
);

/* ================= CREATE SIZE ================= */
export const createSize = createAsyncThunk(
  "size/create",
  async (payload, thunkAPI) => {
    try {
      const res = await api.post(
        "/api/sizes",
        payload
      );
      return res.data.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(
        err.response?.data?.message || "Failed to create size"
      );
    }
  }
);

/* ================= UPDATE SIZE ================= */
export const updateSize = createAsyncThunk(
  "size/update",
  async ({ id, ...payload }, thunkAPI) => {
    try {
      const res = await api.put(
        `/api/sizes/${id}`,
        payload
      );
      return res.data.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(
        err.response?.data?.message || "Failed to update size"
      );
    }
  }
);

/* ================= DELETE SIZE ================= */
export const deleteSize = createAsyncThunk(
  "size/delete",
  async (id, thunkAPI) => {
    try {
      await api.delete(`/api/sizes/${id}`);
      return id;
    } catch (err) {
      return thunkAPI.rejectWithValue("Failed to delete size");
    }
  }
);

/* ================= TOGGLE STATUS ================= */
export const toggleSizeStatus = createAsyncThunk(
  "size/toggleStatus",
  async (id, thunkAPI) => {
    try {
      const res = await api.patch(
        `/api/sizes/${id}/status`
      );
      return res.data.data;
    } catch (err) {
      return thunkAPI.rejectWithValue("Failed to update status");
    }
  }
);

/* ================= SLICE ================= */
const sizeSlice = createSlice({
  name: "size",
  initialState: {
    sizes: [],
    loading: false,
    error: null,
    pagination: {}
  },
  reducers: {},
  extraReducers: (builder) => {
    builder

      /* FETCH */
      .addCase(fetchSizes.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSizes.fulfilled, (state, action) => {
        state.loading = false;
        state.sizes = action.payload.data;
        state.pagination = action.payload.pagination;
      })
      .addCase(fetchSizes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* CREATE */
      .addCase(createSize.fulfilled, (state, action) => {
        state.sizes.unshift(action.payload);
      })

      /* UPDATE */
      .addCase(updateSize.fulfilled, (state, action) => {
        const index = state.sizes.findIndex(
          (s) => s._id === action.payload._id
        );
        if (index !== -1) {
          state.sizes[index] = action.payload;
        }
      })

      /* DELETE */
      .addCase(deleteSize.fulfilled, (state, action) => {
        state.sizes = state.sizes.filter(
          (s) => s._id !== action.payload
        );
      })

      /* TOGGLE STATUS */
      .addCase(toggleSizeStatus.fulfilled, (state, action) => {
        const index = state.sizes.findIndex(
          (s) => s._id === action.payload._id
        );
        if (index !== -1) {
          state.sizes[index] = action.payload;
        }
      });
  }
});

export default sizeSlice.reducer;